import { Sparkles } from "lucide-react";

interface ChatIconButtonProps {
  onClick: () => void;
  unreadCount?: number;
}

export function ChatIconButton({ onClick, unreadCount }: ChatIconButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title="Open assistant (Cmd+I)"
      aria-label="Open assistant chat"
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 32,
        height: 32,
        borderRadius: 8,
        background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,255,255,0.10)",
        cursor: "pointer",
        transition: "background 0.15s",
        flexShrink: 0,
        padding: 0,
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLButtonElement).style.background = "rgba(255,255,255,0.10)";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLButtonElement).style.background = "rgba(255,255,255,0.05)";
      }}
    >
      <Sparkles size={14} style={{ color: "#a78bfa" }} />
      {unreadCount != null && unreadCount > 0 && (
        <span
          style={{
            position: "absolute",
            top: -4,
            right: -4,
            width: 16,
            height: 16,
            borderRadius: "50%",
            background: "#7c3aed",
            color: "white",
            fontSize: 10,
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </button>
  );
}
